var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./preference.constants";
export var create = (_a = generatePromises(GENERATOR_PARAMS), _a.create), update = _a.update;
